import { render, staticRenderFns } from "./QrCustomerJourney.vue?vue&type=template&id=3bb931a3&scoped=true"
import script from "./QrCustomerJourney.vue?vue&type=script&lang=js"
export * from "./QrCustomerJourney.vue?vue&type=script&lang=js"
import style0 from "./QrCustomerJourney.vue?vue&type=style&index=0&id=3bb931a3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb931a3",
  null
  
)

export default component.exports